import { httpsCallable } from 'firebase/functions';
import { sendPasswordResetEmail as firebaseSendPasswordResetEmail } from 'firebase/auth';
import { functions, auth } from './firebase';

// Helper function to ensure user is authenticated before calling functions
const ensureAuthenticated = async () => {
  if (!auth.currentUser) {
    throw new Error('User must be authenticated to perform this action');
  }
  // Force token refresh to ensure we have a valid token
  await auth.currentUser.getIdToken(true);
  return auth.currentUser;
};

// Direct callable functions with authentication check
export const sendPasswordResetEmailAuthenticated = async (data: { email: string }) => {
  await ensureAuthenticated();
  
  try {
    // Use Firebase Auth's built-in password reset email function
    await firebaseSendPasswordResetEmail(auth, data.email);
    return {
      success: true,
      message: `Password reset email sent to ${data.email}`
    };
  } catch (error) {
    console.error('Error sending password reset email:', error);
    throw error;
  }
};

export const deleteUserFromAuthAuthenticated = async (data: { uid: string }) => {
  await ensureAuthenticated();
  const callable = httpsCallable(functions, 'deleteUser');
  return await callable(data);
};

export const deleteAllUserDataAuthenticated = async (uid: string) => {
  await ensureAuthenticated();
  const callable = httpsCallable(functions, 'deleteAllUserData');
  return await callable({ uid });
};

// Keep the original exports for backward compatibility
export const deleteUserFromAuth = httpsCallable(functions, 'deleteUser');
export const deleteAllUserData = httpsCallable(functions, 'deleteAllUserData');

// Alternative: Backend API call (if you prefer REST API over Cloud Functions)
export const deleteUserViaAPI = async (uid: string) => {
  try {
    const response = await fetch('/api/admin/deleteUser', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ uid }),
    });

    if (!response.ok) {
      throw new Error('Failed to delete user from Authentication');
    }

    return await response.json();
  } catch (error) {
    console.error('Error calling delete user API:', error);
    throw error;
  }
};